// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"3b6950f5","703":"79bb1056","787":"e21b44a5"}[chunkId] + ".chunk.js";
};